import { useEffect, useState } from 'react';
import { wdiCore, WdiFormCardTitle, WdiInput } from '@/components/WdiControls';
import { Col, Form, Row } from 'antd';
import { FileUploadUtility, WdiFileList } from '@/components/WdiControls/WdiFileUpload';
import { WdiPanel, WdiPanelProps } from '@/components/WdiControls/WdiPanel';
import { FormApi } from '@/services/sales';
import { FormSaMkt } from '@/services/mkt/sa';
import { BOHQ } from '@/services/mdm/bohq';
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

export type DetailForApplyProps = {
  formRef: any;
  formSaMktId?: number;
} & WdiPanelProps;

const FormSaMktInfosApp: React.FC<DetailForApplyProps> = (props) => {
  const [saMktForm, setSaMktForm] = useState<API.Form>();
  useEffect(() => {
    if (props.formSaMktId && props.formRef) {
      FormSaMkt.get(props.formSaMktId).then(formSaMktResponse => {
        const formSaMkt = formSaMktResponse?.data;
        props.formRef.current?.setFieldsValue({
          SAActivityName: formSaMkt.activityName,
          SAActivityDate: wdiCore.Date.Join(formSaMkt.activityStartDate, formSaMkt.activityEndDate),
          SARemark: formSaMkt.remark,
          SAAttachment: FileUploadUtility.parse(formSaMkt.fileName, formSaMkt.filePath),
        })
        BOHQ.get(formSaMktResponse.data.bohqId ?? 0).then(bohqResponse => {
          const bohq = bohqResponse?.data;
          props.formRef.current?.setFieldsValue({
            SABOHQ: wdiCore.String.Join(bohq.bohqCode, bohq.bohqName),
          })
        })
      })
      FormApi.get(props.formSaMktId).then(saMktFormResponse => {
        setSaMktForm(saMktFormResponse?.data);
        props.formRef.current?.setFieldsValue({
          SAIsSpecialApprove: saMktFormResponse?.data.isSpecialApprove
        })
      })
    }
  }, [props.formSaMktId]);
  return (
    <>
      <WdiPanel
        collapsed={true}
        {...props}
        title={<WdiFormCardTitle title="活动申请单信息" form={saMktForm} isJump={true} />}
      >
        <Row gutter={[16, 24]}>
          <Col className="gutter-row" span={8}>
            <Form.Item name="SAActivityName" label="活动名称">
              <WdiInput readOnly />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={4}>
            <Form.Item name="SAActivityDate" label="活动期间">
              <WdiInput readOnly />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={4}>
            <Form.Item name="SABOHQ" label="预算归属">
              <WdiInput readOnly />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 24]}>
          <Col className="gutter-row" span={16}>
            <Form.Item name="SARemark" label="方案简述">
              <WdiEditor  readOnly={true} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              name="SAAttachment"
              label="附件"
              valuePropName="fileList"
              getValueFromEvent={(e: any) => {
                return e.fileList || [];
              }}
            >
              <WdiFileList />
            </Form.Item>
          </Col>
        </Row>
      </WdiPanel>
    </>
  );
}
export default FormSaMktInfosApp;

